/**
 * RoomDisplay Component
 * 
 * Displays the current room information including room number and
 * procedurally generated description from the CFG.
 * 
 * Accessibility:
 * - Semantic HTML with proper heading hierarchy
 * - ARIA region for screen readers
 * - Clear visual hierarchy
 */

import React from 'react';
import { Room } from '@core/types';
import styles from './RoomDisplay.module.scss';

export interface RoomDisplayProps {
  /** The room to display */
  room: Room;
  /** The room number for display */
  roomNumber: number;
}

/**
 * RoomDisplay component
 * 
 * @example
 * ```tsx
 * <RoomDisplay room={currentRoom} roomNumber={0} />
 * ```
 */
export const RoomDisplay: React.FC<RoomDisplayProps> = ({ room, roomNumber }) => {
  return (
    <section className={styles.roomDisplay} aria-labelledby="room-title" role="region">
      <h2 id="room-title" className={styles.title}>
        Room {roomNumber}
      </h2>
      <p className={styles.description}>{room.description}</p>
    </section>
  );
};